/* Decorative backgrounds keep their original crop and art direction. */
(function () {
  'use strict';
  var selector = '[data-ks-background]';
  var bound = new WeakSet();
  var observer = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        hydrate(entry.target);
      });
    }, { rootMargin: '600px 0px' })
    : null;

  function hydrate(element) {
    if (!element.isConnected || element.dataset.ksBackgroundLoaded) return;
    element.dataset.ksBackgroundLoaded = 'true';
    var desktop = element.dataset.ksBackground || '';
    var mobile = element.dataset.ksBackgroundMobile || desktop;
    var breakpoint = Number(element.dataset.ksBackgroundBreakpoint) || 1023;
    var media = window.matchMedia('(max-width: ' + breakpoint + 'px)');
    function update() {
      if (!element.isConnected) {
        if (media.removeEventListener) media.removeEventListener('change', update);
        else if (media.removeListener) media.removeListener(update);
        return;
      }
      var url = media.matches ? mobile : desktop;
      element.style.backgroundImage = url ? 'url(' + JSON.stringify(url) + ')' : 'none';
    }
    update();
    if (mobile !== desktop) {
      if (media.addEventListener) media.addEventListener('change', update);
      else if (media.addListener) media.addListener(update);
    }
  }

  function bind(root) {
    var elements = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) elements.unshift(root);
    elements.forEach(function (element) {
      if (bound.has(element)) return;
      bound.add(element);
      if (observer) observer.observe(element);
      else hydrate(element);
    });
  }
  bind(document);
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
